import { createFileRoute } from '@tanstack/react-router';
import WeeklyOverview from '~/containers/WeeklyOverview';
import type { SidebarView } from '~/containers/WeeklyOverview/PublisherSidebar';

const isSidebarView = (v: unknown): v is SidebarView =>
  v === 'assigned' || v === 'applied';

export const Route = createFileRoute('/weekplan/$year/$week/overview')({
  component: WeeklyOverview,
  validateSearch(search: Record<string, unknown>) {
    return {
      highlightPublisher: search.highlightPublisher
        ? Number(search.highlightPublisher)
        : undefined,
      sidebarView: isSidebarView(search.sidebarView)
        ? search.sidebarView
        : undefined,
    };
  },
});
